import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Box, Divider } from '@material-ui/core'

import { Flowchart } from 'components'
import {
  DataCollected,
  DataTreatment,
  GeneralInformation,
  DataLifeCycle,
  PaperHeader,
  DataTreatmentAgent,
} from '../../../Show'
import {
  LegalFrameworks,
  Description,
  ShowNecessityProportionality,
  Fragilities,
  InternationalTransfer,
} from '../../../'

import DataCollectedModalProvider from 'providers/DataCollectedModalProvider'
import DataProcessTemplateQuestionProvider from 'providers/DataProcessTemplateQuestionProvider'
import DocumentsProvider from 'providers/DocumentsProvider'

import constants from 'constants/index'
import helpers from 'helpers'

const PaperBody = ({
  isLoading,
  dataProcess,
  origin,
  onlyShow = false,
  refresh = () => {},
  dataProcessTemplate = [],
}) => {
  const history = useHistory()

  const handleBack = () => {
    history.goBack({
      search: localStorage.getItem('ProcessFilters'),
    })
  }

  const dataCollectedsTemplateAnswers = dataProcess.dataCollecteds.flatMap(
    (dataCollected) => {
      return dataCollected.dataProcessTemplateAnswers
    },
  )

  return (
    <>
      <Box id={constants.dataProcess.DATA_PROCESS_NEW_DRIVER_STEP_11}>
        <PaperHeader data={dataProcess} isLoading={isLoading} />
        <DataProcessTemplateQuestionProvider
          step="general_information"
          dataProcessTemplate={dataProcessTemplate}
        >
          <GeneralInformation
            data={dataProcess}
            isLoading={isLoading}
            origin={origin}
            onlyShow={onlyShow}
            hiddenSuggestionAlert={
              !dataProcess?.suggestedChangeStats?.dataProcess
            }
            dataProcessTemplateAnswers={dataProcess.dataProcessTemplateAnswers}
          />
        </DataProcessTemplateQuestionProvider>
      </Box>
      <Divider />
      <Description dataProcess={dataProcess} />
      <Divider />
      <DocumentsProvider
        documents={dataProcess.documents}
        linkedDocuments={dataProcess?.linkedDocuments}
      >
        <DataCollectedModalProvider dataCollecteds={dataProcess.dataCollecteds}>
          <DataCollected
            dataCollecteds={dataProcess.dataCollecteds}
            isLoading={isLoading}
            dataProcessId={dataProcess.id}
            hiddenSuggestionAlert={
              !dataProcess.suggestedChangeStats.dataCollected
            }
            dataProcessTemplateAnswers={dataCollectedsTemplateAnswers}
          />
          <Divider />
          <DataTreatmentAgent data={dataProcess} />
          <Divider />

          <DataLifeCycle
            data={dataProcess}
            isLoading={isLoading}
            hiddenSuggestionAlert={!dataProcess.suggestedChangeStats.lifeCycle}
          />

          <Divider />

          <DataTreatment
            isLoading={isLoading}
            dataTreatments={dataProcess.dataTreatments}
            dataProcessId={dataProcess.id}
            hiddenSuggestionAlert={
              !dataProcess.suggestedChangeStats.dataTreatment
            }
          />
        </DataCollectedModalProvider>
      </DocumentsProvider>

      <Divider />
      {dataProcess?.statusId === constants.dataProcess.APPROVED_STATUS &&
        !onlyShow && (
          <ShowNecessityProportionality data={dataProcess} refresh={refresh} />
        )}
      <Fragilities
        dataProcessId={dataProcess.id}
        onlyShow={onlyShow}
        origin={origin}
      />
      <Divider />
      <Flowchart
        data={helpers.dataProcess.plotFlowchartData(dataProcess)}
        title="Fluxograma de Processamento de Dados"
        description="Este fluxograma ilustra o ciclo de vida dos dados, desde a origem até o armazenamento e disposição final."
      />
      <Divider />
      {!onlyShow && (
        <>
          <LegalFrameworks data={dataProcess} isLoading={isLoading} />
          <InternationalTransfer
            dataProcess={dataProcess}
            isLoading={isLoading}
          />
        </>
      )}
      {!onlyShow && (
        <Button variant="outlined" type="button" onClick={handleBack}>
          Voltar
        </Button>
      )}
    </>
  )
}

export default PaperBody
